import { getConfig } from './config';

export const moneyFormat = "$ 0,0";
export const moneyOnlyFormat = "0,0";
export const dateFormat = "DD/MMM/YYYY";
export const dateTimeFormat = "DD/MM/YYYY HH:mm:ss";
export const jsonDateFormat = "YYYY-MM-DD";

export const tenorOptions = ["1m", "3m", "6m", "12m"];
export const gradeOptions = { low: 1, medium: 2, high: 3 };

const CLIENT_ID = getConfig('GRIFFIN_CLIENT_ID');
const GRIFFIN_URL = getConfig('GRIFFIN_HOST');
const REDIRECT_URI = getConfig('GRIFFIN_REDIRECT_URI');
const BASE_API_URL = getConfig('GRIFFIN_BASE_API_URL');
const LDB_URL = getConfig('LDB_URL');

const LOGOUT_URL = `${GRIFFIN_URL}accounts/logout`
const CHANGE_PASSWORD_URL = `${GRIFFIN_URL}accounts/password_change`

export const transaction = {
  topup: "Top Up",
  cashout: "Cash Out",
};

export const status = {
  approved: "APPROVED",
  pending: "PENDING",
  rejected: "REJECTED",
  completed: "DISBURSED", // in funding service term completed means disbursed
};

export const loanType = {
  revolving: "REVOLVING",
  tenure_based: "TENURE-BASED",
};

export const reportType = {
  approval: "approval",
  borrower: "borrower",
  topupcashout: "topupcashout",
};

export const tableFields = [];

export const csvFields = [
  "Submitted",
  "Status",
  "Status Date",
  "Borrower",
  "App ID",
  "Type",
  "Purpose",
  "Amount",
  "Tenure",
  "Interest (%)",
  "Admin Fee",
  "Penalty",
];

export const modalPopupStates = {
  confirmAllocation: "confirmAllocation",
  errorOccurred: "errorOccurred",
  backendCall: "backendCall",
  editCurrentCycle: "editCurrentCycle",
  autoApproval: "autoApproval",
};

export {
  CLIENT_ID,
  REDIRECT_URI,
  BASE_API_URL,
  LOGOUT_URL,
  CHANGE_PASSWORD_URL,
  GRIFFIN_URL,
  LDB_URL,
}
